import { Component, Fragment } from "react";
import { getStaticText } from "./../../helpers/system";
import ProductText from "./../../const/product.json";
import { properNumber } from "../../helpers/number";
import ContentLoader from "react-content-loader";

const InvestreeTopOrg = "IN002";
export default class ProductDetails extends Component {
    renderProcessingFee() {
        const { product } = this.props;
        const { processingFee: feeRate = 0, config = {} } = product;
        const { processing_fee_amount: feeAmount = 0 } = config;

        if (!feeAmount) {
            return (
                <>
                    {feeRate}
                    {getStaticText(ProductText, "suffixProcessingFee")}
                </>
            );
        }

        if (!feeRate) {
            return (
                <>
                    {getStaticText(ProductText, "prefixProcessingFee")}
                    {properNumber(feeAmount, 2)}
                </>
            );
        }

        return (
            <>
                {feeRate}
                {getStaticText(ProductText, "suffixProcessingFee")} <small>or</small>{" "}
                {getStaticText(ProductText, "prefixProcessingFee")}
                {feeAmount} <small>whichever is higher</small>
            </>
        );
    }

    render() {
        const { product, loanTerm, loanAmount, productReady } = this.props;
        const { productOrg, interestRate, annualPercentageRate, approvalTime } = product;

        const annualInterestRate = annualPercentageRate ?? interestRate * 12;
        const totalRepayment = parseFloat(loanAmount) + (interestRate / 100) * loanTerm * parseFloat(loanAmount);

        return (
            <section id="product-details" className="d-block d-md-none">
                <div className="container-xl">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            {productReady ? (
                                <Fragment>
                                    {productOrg !== InvestreeTopOrg && (
                                        <div className="detail-item">
                                            <div className="label">
                                                {getStaticText(ProductText, ["labelTotal", productOrg])}
                                            </div>
                                            <div className="value">
                                                {getStaticText(ProductText, "prefixTotal")}
                                                {loanAmount ? properNumber(loanAmount, 2) : "------"}
                                            </div>
                                        </div>
                                    )}
                                    <div className="detail-item">
                                        <div className="label">{getStaticText(ProductText, "labelTenor")}</div>
                                        <div className="value">
                                            {loanTerm ? loanTerm : "--"} {loanTerm > 1 ? "Months" : "Month"}
                                        </div>
                                    </div>
                                    <div className="detail-item">
                                        <div className="label">{getStaticText(ProductText, "labelApprovalTime")}</div>
                                        <div className="value">{`${approvalTime} ${
                                            approvalTime > 1 ? "Days" : "Day"
                                        }`}</div>
                                    </div>
                                    <div className="detail-item">
                                        <div className="label">
                                            {getStaticText(ProductText, ["labelInterestRate", productOrg])}
                                        </div>
                                        <div className="value">
                                            {interestRate}
                                            {getStaticText(ProductText, "suffixInterestRate")}
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="label">
                                            {getStaticText(ProductText, ["labelAnnualInterestRate", productOrg])}
                                        </div>
                                        <div className="value">
                                            {annualInterestRate}
                                            {getStaticText(ProductText, "suffixAnnualInterestRate")}
                                        </div>
                                    </div>
                                    <div className="detail-item">
                                        <div className="label">{getStaticText(ProductText, "labelProcessingFee")}</div>
                                        <div className="value">{this.renderProcessingFee()}</div>
                                    </div>
                                    {productOrg !== InvestreeTopOrg && (
                                        <div className="detail-item">
                                            <div className="label">
                                                {getStaticText(ProductText, "labelTotalRepayment")}
                                            </div>
                                            <div className="value">
                                                {getStaticText(ProductText, "prefixTotalRepayment")}
                                                {totalRepayment ? properNumber(totalRepayment, 2) : "------"}
                                            </div>
                                        </div>
                                    )}
                                </Fragment>
                            ) : (
                                <div className="loading">
                                    <ContentLoader width="100%">
                                        <rect width="30%" height="20" x="0" y="0" />
                                        <rect width="100%" height="20" x="0" y="70" />
                                    </ContentLoader>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
